import axios from 'axios';
import { API_URL } from '../config';
import initialState from './initialState';

const reducerName = 'microbiology';
const createActionName = (name) => `app/${reducerName}/${name}`;

export const LOAD_MICROBIOLOGY_1 = createActionName('LOAD_MICROBIOLOGY_1');
export const ADD_MICROBIOLOGY_1 = createActionName('ADD_MICROBIOLOGY_1');
export const EDIT_MICROBIOLOGY_1 = createActionName('EDIT_MICROBIOLOGY_1');
export const DELETE_MICROBIOLOGY_1 = createActionName('DELETE_MICROBIOLOGY_1');

export const loadMicrobiology_1 = (payload) => ({
  payload,
  type: LOAD_MICROBIOLOGY_1,
});
export const addMicrobiology_1 = (payload) => ({
  payload,
  type: ADD_MICROBIOLOGY_1,
});
export const editMicrobiology_1 = (payload) => ({
  payload,
  type: EDIT_MICROBIOLOGY_1,
});
export const deleteMicrobiology_1 = (payload) => ({
  payload,
  type: DELETE_MICROBIOLOGY_1,
});

export const createMicrobiology1Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/microbiology`, data, {
        withCredentials: true,
      });
      dispatch(addMicrobiology_1(res.data));
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const removeMicrobiology1Request = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.delete(`${API_URL}/microbiology/${id}`, {
        withCredentials: true,
      });
      dispatch(deleteMicrobiology_1({ id }));
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createSamplerRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/microbiology/sampler`, data, {
        withCredentials: true,
      });

      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const removeSamplerRequest = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.delete(`${API_URL}/microbiology/sampler/${id}`, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createMicroBottlingRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/microbiology/bottling`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const updateMicroBottlingRequest = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(
        `${API_URL}/microbiology/bottling/${data.id}`,
        data,
        {
          withCredentials: true,
        },
      );
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createMicro3Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/microbiology/micro3`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const deleteMicro3Request = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.delete(`${API_URL}/microbiology/micro3/${id}`, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createMicro4Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/microbiology/micro4`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const updateMicro4Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(
        `${API_URL}/microbiology/micro4/${data.id}`,
        data,
        {
          withCredentials: true,
        },
      );
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createMicro5Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/microbiology/micro5`, data, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const updateMicro5Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(
        `${API_URL}/microbiology/micro5/${data.id}`,
        data,
        {
          withCredentials: true,
        },
      );
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

const microbiology1Reducer = (statePart = initialState, action) => {
  switch (action.type) {
    case LOAD_MICROBIOLOGY_1:
      return action.payload;
    case ADD_MICROBIOLOGY_1:
      return [...statePart, action.payload];
    case EDIT_MICROBIOLOGY_1:
      return statePart.map((microbiology_1) =>
        microbiology_1.id === action.payload.id
          ? action.payload
          : microbiology_1,
      );
    case DELETE_MICROBIOLOGY_1:
      return statePart.filter(
        (microbiology_1) => microbiology_1.id !== action.payload.id,
      );
    default:
      return statePart;
  }
};

export default microbiology1Reducer;
